module.exports = __webpack_public_path__ + "img/banquan.e0c86c03.png";